'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');let

TreeListDirectiveController=function(_BaseController){_inherits(TreeListDirectiveController,_BaseController);
function TreeListDirectiveController($scope,uncaughtErrorHandler,sidebarScrollingService){_classCallCheck(this,TreeListDirectiveController);var _this=_possibleConstructorReturn(this,
_BaseController.call(this,uncaughtErrorHandler,void 0,$scope));

_this._sidebarScrollingService=sidebarScrollingService;
_this._expandedItems=_this.expandedItems||null;

$scope.$watchGroup([
'controller.selectedItem',
'controller.expandedItems'],
_.debounce(function(){return _this._scrollToSelection(_this.selectedItem)},150));

_this._resetItemToElementMap();
_this._safeWatch('items',function(n,o){return _this._resetItemToElementMap()});return _this;
}TreeListDirectiveController.prototype.





_resetItemToElementMap=function _resetItemToElementMap(){
this.itemToElementMap=new Map;
};TreeListDirectiveController.prototype.

_scrollToSelection=function(){var ref=_asyncToGenerator(function*(item){
yield this._sidebarScrollingService.scrollToSelection(item,this.itemToElementMap);
});function _scrollToSelection(item){return ref.apply(this,arguments)}return _scrollToSelection}();TreeListDirectiveController.prototype.

toggleIsExpanded=function toggleIsExpanded(item){
if(!this._isInitialized){
return;
}

if(this.isExpanded(item)){
this._expandedItemSet.delete(item);
}else{
this._expandedItemSet.add(item);
}

this._expandedItems=[].concat(_toConsumableArray(this._expandedItemSet));
};TreeListDirectiveController.prototype.

isExpanded=function isExpanded(item){
return this._isInitialized&&this._expandedItemSet.has(item);
};_createClass(TreeListDirectiveController,[{key:'_isInitialized',get:function(){return _.exists(this._expandedItems)}},{key:'expandedItems',set:function(

newExpandedItems){
if(!_.exists(newExpandedItems)){
return;
}

this._expandedItems=newExpandedItems;
this._expandedItemSet=new Set(newExpandedItems);
},get:function()

{
return this._expandedItems;
}}]);return TreeListDirectiveController}(BaseController);let


TreeListDirective=function(_BaseControllerBacked){_inherits(TreeListDirective,_BaseControllerBacked);function TreeListDirective(){_classCallCheck(this,TreeListDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}TreeListDirective.prototype.












factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
directive.transclude=!0;
return directive;
};_createClass(TreeListDirective,[{key:'objectBindings',get:function(){return['items','selectedItem','order','expandedItems']}},{key:'templateUrl',get:function(){return'/templates/directives/treeListDirective/treeListTemplate'}},{key:'controller',get:function(){return TreeListDirectiveController}}]);return TreeListDirective}(BaseControllerBackedDirective);


module.exports=TreeListDirective;
//# sourceMappingURL=treeListDirective.js.map
